import * as Types from '../../../../graphql-types'

import { gql } from '@apollo/client'
import { ContentDetails_Tag_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsTagContentReferenceFragment.generated'
import { Content_ProviderMetadataFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderMetadataFragment.generated'
export type YiCourseSection_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  title?: string | null
  contentType?: string | null
  contentId?: number | null
  published?: boolean | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      yiTagGroup?: Array<{
        __typename?: 'ContentReference'
        contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
      } | null> | null
    } | null> | null
  } | null> | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export const YiCourseSection_ContentFragmentFragmentDoc = gql`
  fragment YICourseSection_ContentFragment on Content {
    id
    title
    contentType
    contentId
    published
    yiContentType: contentReferencesFrom(types: "yi-content-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    ...Content_ProviderMetadataFragment
  }
  ${ContentDetails_Tag_ContentReferenceFragmentFragmentDoc}
  ${Content_ProviderMetadataFragmentFragmentDoc}
`
